export const removeTargetedOffers = ({ updateState }) => {
  updateState({
    targetedOffers: [],
    targetedOffersLoading: false,
    targetedOfferApplied: {},
    targetedOfferSelected: {},
    targetedOffersDisabledMessage: {},
    errorTargetedOffers: {
      code: null,
      isNetWorkError: false,
    },
    targetedOffersLogged: false,
    targetedFilters: {},
    targetedOffersQuery: {},
    errorTargetedOfferMessage: '',
    loginOrigin: '',
    isInvalidEmailOrCASId: false,
  });
};
